import styled from "styled-components";

export const ContainerTitle = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const TotalValue = styled.h3`
  background-color: #666;
  border-radius: 0 25px 25px 0;
  box-shadow: 0 3px 2px 1px rgba(0, 0, 0, 0.2);
  color: #2afaa5;
  display: flex;
  font-size: 18px;
  margin: 15px 0;
  padding: 10px;
`;

export const PlayngTime = styled.button`
  align-items: center;
  background-color: #eb6d03;
  border-radius: 25px 0 0 25px;
  color: #fff;
  display: flex;
  font-size: 18px;
  height: 45px;
  justify-content: flex-start;
  margin-top: 10px;
  padding-right: 15px;
  padding-left: 15px;
  max-width: 50%;
`;

export const HeaderImg = styled.img`
  padding-right: 5px;
  width: 18px;
`;
